import { render, staticRenderFns } from "./MemoValidationModal.vue?vue&type=template&id=2337392c&"
import script from "./MemoValidationModal.vue?vue&type=script&lang=js&"
export * from "./MemoValidationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports